import { Button } from '@factorialco/deprecated-design-system'
import {
  BenefitsSettingsPageDocument,
  SaveBenefitsBenefitSettingDocument,
  type SaveBenefitsBenefitSettingMutation,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import {
  trackCancelResetDayChange,
  trackConfirmResetDayChange,
} from 'modules/benefits/lib/trackBenefitsSettings'

type Props = {
  onClose: () => void
  companyId: number
  selectedResetDay: number
  currentResetDay: number
}

const ResetDayUpdateModal = ({ onClose, companyId, selectedResetDay, currentResetDay }: Props) => {
  const [saveBenefitsSetting] = useMutation(SaveBenefitsBenefitSettingDocument, {
    extractorFn: (payload: SaveBenefitsBenefitSettingMutation) =>
      payload.benefitsMutations.saveBenefitsBenefitSetting,
    refetchQueries: [
      {
        query: BenefitsSettingsPageDocument,
        variables: { companyId },
      },
    ],
  })

  const handleConfirm = async () => {
    const toSave = Number(selectedResetDay)
    const currentDay = Number(currentResetDay)

    // Track the confirm action
    trackConfirmResetDayChange(currentDay, toSave)

    const result = await saveBenefitsSetting({
      variables: { companyId, resetDay: toSave },
    })
    const { success } = handleResult(result, () => {})

    if (success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      onClose()
    }
  }

  const handleCancel = () => {
    // Track the cancel action
    trackCancelResetDayChange()

    onClose()
  }

  return (
    <Modal
      illustration="page-edit"
      title={i18n.t('benefits.settings.reset_day.save_closure_date_question')}
      description={i18n.t('benefits.settings.reset_day.confirm_body', {
        day_number: selectedResetDay,
      })}
      onClose={handleCancel}
      footer={
        <>
          <Button type="secondary" onClick={handleCancel}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={handleConfirm}>{i18n.t('common.confirm')}</Button>
        </>
      }
    />
  )
}

export default ResetDayUpdateModal
